import React, { useEffect, useState } from 'react';
import { Button } from 'types/ButtonTypes';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/alerts/Tooltip';
import '../../style/scss/button.scss';
import '../../style/scss/tooltip.scss';

const IconButton: React.FC<Button> = ({ 
    onClick, 
    type, 
    icon, 
    label, 
    size = 'medium', 
    isActive, 
    tooltipText,
    tooltipPosition,
    loading = false,
}) => {
    const { t } = useTranslation();

    // Set the size classes
    const buttonSizeClass = `button-${size}`;
    const buttonLoadingClass = loading ? 'button-loading' : '';

    // Give the loader icon a delay, so it looks smoother
    const [showLoaderWithDelay, setShowLoaderWithDelay] = useState(false);
    useEffect(() => {
        let timer: number;
        if (loading) {
            timer = window.setTimeout(() => setShowLoaderWithDelay(true), 150)
        } else {
            setShowLoaderWithDelay(false);
        }
        return () => clearTimeout(timer);
    }, [loading]);
    
    return (
        <div>
            <button 
                type={type}
                onClick={onClick}
                className={`
                    button 
                    button-secondary 
                    icon-button 
                    ${buttonLoadingClass} 
                    ${buttonSizeClass} 
                    tooltip-hover 
                    ${isActive ? 'button-active' : ''}
                    ${(icon && !label) ? 'icon-button-only-icon' : ''}
                `}
            >
                <span style={{ visibility: loading ? 'hidden' : 'visible' }}>
                    {icon && icon}
                    {label && 
                        <span className='icon-button-label'>{t(label)}</span>
                    }
                </span>
                {showLoaderWithDelay && 
                    <div className='loader-container'>
                        <div className='button-loader'></div>
                    </div>
                }
                {tooltipText &&
                    <Tooltip position={tooltipPosition}>{t(tooltipText)}</Tooltip>
                }
            </button>
        </div>
    );
};

export default IconButton;